import React from 'react';
import { IMAGES, BIO } from '../mock';
import Reveal from './Reveal';

const About = () => {
  return (
    <section id="about" className="relative bg-ink">
      <div className="grid lg:grid-cols-2">
        {/* Portrait */}
        <div className="relative min-h-[55vh] overflow-hidden lg:min-h-0">
          <img
            src={IMAGES.about}
            alt="Kanwal Malik portrait"
            className="absolute inset-0 h-full w-full object-cover object-bottom transition-transform duration-1000 ease-out hover:scale-[1.03]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
        </div>

        {/* Cream panel */}
        <div className="relative overflow-hidden bg-cream px-8 py-14 md:px-16 md:py-20 lg:px-20">
          <Reveal>
            <p className="mb-6 text-[10px] uppercase tracking-[0.5em] text-gold-dark">
              {BIO.tagline}
            </p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-4xl font-light leading-tight tracking-[0.04em] text-ink md:text-5xl">
              {BIO.headingTop}
              <br />
              {BIO.headingBottom}
            </h2>
          </Reveal>
          <Reveal delay={220}>
            <div className="mt-6 h-px w-12 bg-gold" />
          </Reveal>
          <Reveal delay={300}>
            <div className="mt-8 max-w-lg space-y-5">
              {BIO.paragraphs.map((p, i) => (
                <p
                  key={p}
                  className={
                    i === 0
                      ? 'text-base leading-relaxed text-ink/80'
                      : 'text-base leading-relaxed text-ink/70'
                  }
                >
                  {p}
                </p>
              ))}
            </div>
          </Reveal>

          {/* Script watermark */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-3 bottom-8 select-none text-right font-script text-6xl leading-[1.15] text-ink/[0.08] md:text-7xl"
          >
            Music
            <br />
            People
            <br />
            Purpose
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
